import { gradeColor } from "../lib/grade";

interface Props {
  score: number | null | undefined;
  grade: string | null | undefined;
  size?: number;
}

/** A circular SVG progress ring of score (0-100), grade letter centered, coloured by grade. */
export default function ScoreGauge({ score, grade, size = 168 }: Props) {
  const stroke = Math.round(size * 0.085);
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, score ?? 0));
  const dash = (pct / 100) * c;
  const color = gradeColor(grade);
  const center = size / 2;

  return (
    <div className="score-gauge" style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle
          cx={center}
          cy={center}
          r={r}
          fill="none"
          stroke="var(--ring-track)"
          strokeWidth={stroke}
        />
        <circle
          cx={center}
          cy={center}
          r={r}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={`${dash} ${c}`}
          transform={`rotate(-90 ${center} ${center})`}
          style={{ transition: "stroke-dasharray 0.6s cubic-bezier(0.4,0,0.2,1)" }}
        />
      </svg>
      <div className="score-gauge-center">
        <span className="grade-letter" style={{ color }}>
          {grade ?? "—"}
        </span>
        <span className="score-number">{score ?? "—"}</span>
      </div>
    </div>
  );
}
